import React from 'react';

const Check = () => (
  <svg viewBox="0 0 20 20" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4.5 10.5l3.5 3.5 7.5-8" />
  </svg>
);

/**
 * steps: [{ label, sub }]   current: 1-based   onStepClick(stepNumber) – only fires for completed steps
 */
const WizardStepper = ({ steps, current, onStepClick }) => {
  const total = steps.length;
  const percent = Math.round(((current - 1) / (total - 1)) * 100);

  return (
    <nav aria-label="Onboarding progress" className="border-b border-gray-200 bg-gray-50/80 px-6 py-6 md:px-10">
      {/* summary line */}
      <div className="mb-5 flex items-end justify-between">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-700">
            Step {current} of {total}
          </p>
          <h1 className="mt-0.5 text-lg font-bold text-gray-900 md:text-xl">{steps[current - 1].sub}</h1>
        </div>
        <p className="text-sm font-semibold tabular-nums text-gray-500">{percent}% complete</p>
      </div>

      {/* mobile: slim bar */}
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-200 md:hidden" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}>
        <div className="h-full rounded-full bg-blue-700 transition-all duration-500" style={{ width: `${percent}%` }} />
      </div>

      {/* desktop: numbered stepper */}
      <ol className="hidden md:flex">
        {steps.map((s, i) => {
          const n = i + 1;
          const done = n < current;
          const active = n === current;
          const clickable = done && onStepClick;

          return (
            <li key={s.label} className="relative flex flex-1 flex-col items-center">
              {i < total - 1 && (
                <div className="absolute left-1/2 top-[19px] h-0.5 w-full bg-gray-200" aria-hidden="true">
                  <div className={`h-full bg-blue-700 transition-all duration-500 ${done ? 'w-full' : 'w-0'}`} />
                </div>
              )}

              <button
                type="button"
                disabled={!clickable}
                onClick={() => clickable && onStepClick(n)}
                aria-current={active ? 'step' : undefined}
                className={`relative z-10 flex h-10 w-10 items-center justify-center rounded-full p-0 text-sm font-bold leading-none disabled:!opacity-100 transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 ${
                  done
                    ? 'cursor-pointer !border-2 !border-blue-700 !bg-blue-700 !text-white hover:!bg-blue-800'
                    : active
                    ? 'cursor-default !border-2 !border-blue-700 !bg-white !text-blue-700 shadow-md ring-4 ring-blue-100'
                    : 'cursor-default !border-2 !border-gray-300 !bg-white !text-gray-400'
                }`}
              >
                {done ? <Check /> : n}
              </button>

              <span className={`mt-2.5 text-[13px] font-semibold ${active ? 'text-gray-900' : done ? 'text-gray-700' : 'text-gray-400'}`}>
                {s.label}
              </span>
              <span className={`text-[11px] ${active ? 'text-blue-700' : 'text-gray-400'}`}>
                {done ? 'Completed' : active ? 'In progress' : 'Pending'}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default WizardStepper;